import React from 'react';

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function Glyph({ children }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {children}
    </svg>
  );
}

const ICONS = {
  leaf: () => (
    <Glyph>
      <path {...stroke} d="M5 19C13 18 17 13 19 5 11 6 7 11 5 19Z" />
      <path {...stroke} d="M8.2 15.8C10.2 13.6 13 11 16.2 8.2" />
    </Glyph>
  ),
  bag: () => (
    <Glyph>
      <path {...stroke} d="M6.5 8h11l-.8 11.2a1.5 1.5 0 0 1-1.5 1.3H8.8a1.5 1.5 0 0 1-1.5-1.3L6.5 8Z" />
      <path {...stroke} d="M9 8V6.8A3 3 0 0 1 12 3.8 3 3 0 0 1 15 6.8V8" />
    </Glyph>
  ),
  star: () => (
    <Glyph>
      <path {...stroke} d="m12 3.4 2.1 5.2 5.6.5-4.2 3.6 1.3 5.5L12 15.6 7.2 18.2 8.5 12.7 4.3 9.1l5.6-.5L12 3.4Z" />
    </Glyph>
  ),
  person: () => (
    <Glyph>
      <circle {...stroke} cx="12" cy="8" r="3" />
      <path {...stroke} d="M6 19.2c1.1-3 3.2-4.5 6-4.5s4.9 1.5 6 4.5" />
    </Glyph>
  ),
  mail: () => (
    <Glyph>
      <rect {...stroke} x="3.5" y="5.5" width="17" height="13" rx="1.6" />
      <path {...stroke} d="m4.2 7.2 7.8 5.6 7.8-5.6" />
    </Glyph>
  ),
  return: () => (
    <Glyph>
      <path {...stroke} d="M4.5 11h10.2a4 4 0 1 1 0 8H9" />
      <path {...stroke} d="M7.2 8.2 4.2 11l3 2.8" />
    </Glyph>
  ),
  shield: () => (
    <Glyph>
      <path {...stroke} d="M12 3.4 19 6.4v5.2c0 4.1-2.7 7-7 8.6-4.3-1.6-7-4.5-7-8.6V6.4L12 3.4Z" />
    </Glyph>
  ),
  document: () => (
    <Glyph>
      <path {...stroke} d="M7 3.5h7.2L18.5 8v12.5H7V3.5Z" />
      <path {...stroke} d="M14 3.6V8h4.4M9.5 12.5h5M9.5 16h5" />
    </Glyph>
  ),
  userPlus: () => (
    <Glyph>
      <circle {...stroke} cx="9.5" cy="8" r="2.8" />
      <path {...stroke} d="M4.2 19c.9-2.7 2.8-4 5.3-4 1.1 0 2.1.3 3 .8" />
      <path {...stroke} d="M17.2 10.2v5.6M14.4 13h5.6" />
    </Glyph>
  ),
  key: () => (
    <Glyph>
      <circle {...stroke} cx="8" cy="12" r="3.1" />
      <path {...stroke} d="M11 12h8.2M16.4 12v2.2" />
    </Glyph>
  ),
  receipt: () => (
    <Glyph>
      <path {...stroke} d="M7 3.5h10v17l-2-1.1-2 1.1-2-1.1-2 1.1-2-1.1V3.5Z" />
      <path {...stroke} d="M9.5 8h5M9.5 12h5" />
    </Glyph>
  ),
  pin: () => (
    <Glyph>
      <path {...stroke} d="M12 21s5.5-4.8 5.5-9.2a5.5 5.5 0 1 0-11 0C6.5 16.2 12 21 12 21Z" />
      <circle {...stroke} cx="12" cy="11.6" r="1.7" />
    </Glyph>
  ),
  card: () => (
    <Glyph>
      <rect {...stroke} x="3.2" y="6" width="17.6" height="12" rx="1.6" />
      <path {...stroke} d="M3.2 10h17.6" />
    </Glyph>
  ),
  id: () => (
    <Glyph>
      <rect {...stroke} x="3.2" y="5.5" width="17.6" height="13" rx="1.6" />
      <circle {...stroke} cx="8.8" cy="11" r="1.7" />
      <path {...stroke} d="M6.4 15.4c.5-1.3 1.4-1.9 2.4-1.9s1.9.6 2.4 1.9M13.6 10h4M13.6 13.2h3" />
    </Glyph>
  ),
  check: () => (
    <Glyph>
      <circle {...stroke} cx="12" cy="12" r="8" />
      <path {...stroke} d="m8.4 12.2 2.4 2.4 4.8-5.2" />
    </Glyph>
  ),
  cancel: () => (
    <Glyph>
      <circle {...stroke} cx="12" cy="12" r="8" />
      <path {...stroke} d="m9 9 6 6M15 9l-6 6" />
    </Glyph>
  ),
  boxes: () => (
    <Glyph>
      <path {...stroke} d="m4 8.4 8-4 8 4v7.2l-8 4-8-4V8.4Z" />
      <path {...stroke} d="m12 12.4 8-4M12 12.4v7.2M12 12.4 4 8.4" />
    </Glyph>
  ),
};

function PageHeading({ as: Tag = 'h1', icon, className, children }) {
  const Graphic = ICONS[icon];
  const classes = ['Page-header', className].filter(Boolean).join(' ');
  return (
    <Tag className={classes}>
      {Graphic ? <Graphic /> : null}
      <span>{children}</span>
    </Tag>
  );
}

export default PageHeading;
